<mat-select #audienceSelect SelectUi [multiple]="multiple" (selectionChange)="onSelectionChange($event.value)" [(ngModel)]="value" multiple>
  <mat-option [value]="item.id" *ngFor="let item of audiences.items">{{item?.name | titlecase}}
  </mat-option>
</mat-select>
<div class="append flex">
  <i class="fa fa-spinner fa-spin" *ngIf="audiences?.isLoading"></i>
  <img *ngIf="!audiences?.isLoading" (click)="audienceSelect?.open()" src="../../../../../assets/images/icon_drop down.png">
</div>